
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'reco',
  data() {
    return {
      reco: 'https://doc.360medics.com/assets/media/cngof/Synthesesurveillanceposttherapeutique.pdf',
    };
  },
  methods: {
    isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    },
  },
});

